import React from 'react';
export const Zero = () => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "34", height: "40" },
    React.createElement("path", { d: "M17,40C7.8,40,0,33.2,0,20.2C0,6.6,8.1,0,17.3,0C26.4,0,34,6.5,34,19.9S26.3,40,17,40z M17.1,39c4,0,5.2-6.1,5.2-18.7 C22.3,7,21,1.1,17.1,1.1c-4,0-5.4,6-5.4,18.7C11.7,32.8,13.1,38.9,17.1,39L17.1,39z" })));
